module.exports = "https://cdn.dashboard.gifty.nl/5838/images/timer-white.png?1784da3519c3118cfd2ac85aaae94bd7";